module.exports = __webpack_public_path__ + "04ce9d6509c4f40e19324d7909f4f0f7.png";